import React from 'react';
import { connect } from 'react-redux';
import Tabs from '../common/NavigationTabs';
import LoadingSpinner from '../common/LoadingSpinner';
import platediconwhite from '../../assets/images/plated-icon.svg';
import platedicon from '../../assets/images/plated-icon---green.svg';
import vestpa from '../../assets/images/vestpa---green.svg'
import vestpawhite from '../../assets/images/vestpa.svg'
import successwhite from '../../assets/images/success-white.svg';
import success from '../../assets/images/success.svg';


class OrderStatusPage extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
          orderStatus: "complete",
          orderReceived: false,
          orderConfirmed: false,
          orderOnTheWay: false,
          orderComplete: false,

        }
    };

    
    orderStatusCompletedProgressClass(status) {
      switch(status) {
        case 'received':
          return 'received';
        case 'confirmed':   
          return 'confirmed';
        case 'ontheway':    
          return 'ontheway';
        case 'complete':     
          return 'complete'
        default:
          return "received"
      }
    }

    orderStatusRemainingProgressClass(status) {
      switch(status) {
        case 'received':
          return 'incomplete-received';
        case 'confirmed':
          return 'incomplete-confirmed';
        case 'ontheway':
          return 'incomplete-ontheway';
        case 'complete':
          return 'incomplete';
        default:
          return "incomplete-received"
      }
    }

    render() {
        if (this.props.loading) {
            return (
                <LoadingSpinner />
            );
        }

        var status = this.state.orderStatus;

        return (
            <div className="body">
               <div className="breakpointContainer">
                   <div className="section success">
                       <div className="animation">
                           
                       </div>
                       <div className="confirmation-info">
                           <h2 className="big-heading">Yes!<br></br> Your <span className="text-span-5">Eats</span> have been confirmed...</h2>
                           <p className="paragraph centred">Order Confirmation Number: #2034334</p>
                           <p className="paragraph centred top-pad smaller">If you&#x27;ve requested delivery, an estimated delivery time will be sent to you momentarily.</p>
                       </div>
                           <div className="order-status-wrapper">
                            <div className="order-status">
                              <div className="order-status-1">
                                <div  className={ (status === "received" || status === "confirmed" || status === "ontheway" || status === "complete"  ) ? "status-icon success" : "status-icon" }><img src={(status === "received" || status === "confirmed" || status === "ontheway" || status === "complete"  ) ? successwhite : success} loading="lazy" alt="" className="status-icon-pic success" /></div>
                                <div  className="status-description">Order<br></br> Received</div>
                              </div>
                              <div className="order-status-1">
                                <div  className={ ( status === "confirmed" || status === "ontheway" || status === "complete"  ) ? "status-icon success" : "status-icon" }><img src={(status === "confirmed" || status === "ontheway" || status === "complete"  ) ? successwhite : success} loading="lazy" alt="" className="status-icon-pic success" /></div>
                                <div  className="status-description">Order<br></br> confirmed</div>
                              </div>
                              <div className="order-status-1">
                                <div className={ ( status === "ontheway" || status === "complete"  )? "status-icon success" : "status-icon" }><img src={( status === "ontheway" || status === "complete"  )? vestpawhite : vestpa } loading="lazy" alt="" className="status-icon-pic" /></div>
                                <div  className="status-description">Order <br></br>on the way</div>
                              </div>
                              <div className="order-status-1">
                                <div  className={ (  status === "complete"  ) ? "status-icon success" : "status-icon" }><img src={(  status === "complete"  ) ? platediconwhite : platedicon} loading="lazy" alt="" className="status-icon-pic" /></div>
                                <div  className="status-description">Order<br></br> complete </div>
                              </div>
                            </div>
                            <div className={"line " + this.orderStatusCompletedProgressClass(this.state.orderStatus)}></div>
                            <div className={"line " + this.orderStatusRemainingProgressClass(this.state.orderStatus)}></div>
                          </div>
                       
                   </div>
               </div>
               <Tabs 
                    lid={this.props.match.params.lid}
                    section="status"
                />
            </div>
        );
    }
}

export default connect()(OrderStatusPage);